// checkbox-filter.component.ts
import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

@Component({
    selector: 'app-checkbox-filter',
    templateUrl: './custom-checkbox-filter.component.html',
    styleUrls: ['./custom-checkbox-filter.component.scss']
})
export class CustomCheckboxFilterComponent implements IFilterAngularComp {
    private params: IFilterParams;
    filterValue: boolean | null = null;

    agInit(params: IFilterParams): void {
        this.params = params;
    }

    isFilterActive(): boolean {
        return this.filterValue !== null;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        const value = params.data[this.params.colDef.field];
        return this.filterValue === value;
    }

    getModel(): any {
        if (!this.isFilterActive()) {
            return null;
        }
        return {
            filterType: 'checkbox',
            type: 'equals',
            filter: this.filterValue
        };
    }

    setModel(model: any): void {
        this.filterValue = model ? model.filter : null;
    }

    onFilterChange(): void {
        this.params.filterChangedCallback();
    }

    resetFilter(): void {
        this.filterValue = null;
        this.params.filterChangedCallback();
    }
}
